<template>
  <b-form-group :label="title" label-for="image">
    <validation-provider #default="{ errors }" :rules="{ required: required }" :name="title">
      <b-media no-body vertical-align="center" class="flex-column flex-md-row" @drop.prevent="dropImageUpload"
        @dragover.prevent>
        <b-media-aside style="width: 300px;">
          <b-img :src="featuredImage" width="auto" height="200" class="rounded object-cover mr-2 mb-1 mb-md-0" />
        </b-media-aside>
        <b-media-body>
          <small class="text-muted">Gerekli görüntü çözünürlüğü 1920x1080, görüntü
            boyutu 10mb.</small>
          <b-card-text class="my-50">
            <b-link id="blog-image-text">
              C:\fakepath\{{
              image ? image.name : "banner.jpg"
              }}
            </b-link>
          </b-card-text>
          <div class="d-inline-block">
            <b-form-file v-model="image" accept=".jpg,.png,.gif" placeholder="Lütfen bir görsel seçiniz"
              @change="handleImageUpload" />
          </div>
        </b-media-body>
      </b-media>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>
<script>
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BCol,
  BImg,
  BRow,
  BLink,
  BCard,
  BButton,
  BForm,
  BMedia,
  BAlert,
  BSpinner,
  BFormFile,
  BCardText,
  BMediaBody,
  BFormInput,
  BFormGroup,
  BMediaAside,
  BInputGroup,
  BFormTextarea,
  BButtonToolbar,
} from "bootstrap-vue";

import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";

export default {
  components: {
    BCol,
    BImg,
    BRow,
    BLink,
    BCard,
    BButton,
    BForm,
    BMedia,
    BAlert,
    BSpinner,
    BFormFile,
    BCardText,
    BMediaBody,
    BFormInput,
    BFormGroup,
    BMediaAside,
    BInputGroup,
    BFormTextarea,
    BButtonToolbar,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
  },
  directives: {
    Ripple,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    imageUrl: {},
    required: Boolean,
    featuredImageFromApi:String,
  },
  data() {
    return {
      image: null,
      featuredImage:this.featuredImageFromApi != null ? this.featuredImageFromApi : require("@/assets/images/placeholder/1920x1080.jpg"),
    };
  },
  watch: {},
  methods: {
    dropImageUpload(event) {
      this.image = event.dataTransfer.files[0]
      this.featuredImage = URL.createObjectURL(this.image)
    },
    handleImageUpload(event) {
      this.image = event.target.files[0];
      this.featuredImage = URL.createObjectURL(this.image)
    },
  },
  mounted() {
    console.log(this.imageUrl)
    if (this.imageUrl != null) {
      this.featuredImage = this.imageUrl
    }
  },
  setup() {
  },
};
</script>